import React, { useRef, useState } from 'react';
import { useIntersection } from '../hooks/useScrolled';
import './ContactSection.css';

export default function ContactSection() {
  const ref = useRef(null);
  const visible = useIntersection(ref);
  const [form, setForm] = useState({ name: '', phone: '', email: '', location: '' });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) =>
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 3500);
    setForm({ name: '', phone: '', email: '', location: '' });
  };

  return (
    <section className="contact" id="contact" ref={ref}>
      <div className={`contact__inner${visible ? ' visible' : ''}`}>
        {/* LEFT: Form */}
        <div className="contact__form-panel">
          <h2 className="contact__title">Contact Us or Visit</h2>
          <div className="gold-divider" style={{ marginBottom: '6px', marginTop: '12px' }} />
          <p className="contact__sub">
            To know more about our Gold Advance Booking scheme &amp; Wedding
            purchases, kindly drop your contact details.
          </p>

          {submitted ? (
            <div className="contact__success">
              <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
                <circle cx="14" cy="14" r="13" stroke="#8B0000" strokeWidth="1.5"/>
                <path d="M8 14l4 4 8-8" stroke="#8B0000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <p>Thank you! We will contact you shortly.</p>
            </div>
          ) : (
            <form className="contact__form" onSubmit={handleSubmit}>
              <div className="contact__form-row">
                <div className="contact__field">
                  <input
                    type="text"
                    name="name"
                    placeholder="Your name"
                    value={form.name}
                    onChange={handleChange}
                    required
                    className="contact__input"
                  />
                </div>
                <div className="contact__field">
                  <input
                    type="tel"
                    name="phone"
                    placeholder="Your phone"
                    value={form.phone}
                    onChange={handleChange}
                    required
                    className="contact__input"
                  />
                </div>
              </div>

              <div className="contact__form-row">
                <div className="contact__field">
                  <input
                    type="email"
                    name="email"
                    placeholder="Your email"
                    value={form.email}
                    onChange={handleChange}
                    required
                    className="contact__input"
                  />
                </div>
                <div className="contact__field">
                  <input
                    type="text"
                    name="location"
                    placeholder="Your location"
                    value={form.location}
                    onChange={handleChange}
                    className="contact__input"
                  />
                </div>
              </div>

              {/* reCAPTCHA mock */}
              <div className="contact__recaptcha">
                <label className="recaptcha-label">
                  <input type="checkbox" required />
                  <span className="recaptcha-text">I'm not a robot</span>
                  <div className="recaptcha-logo">
                    <svg width="34" height="34" viewBox="0 0 34 34" fill="none">
                      <rect width="34" height="34" rx="3" fill="#F5F5F5"/>
                      <path d="M17 7c-5.52 0-10 4.48-10 10s4.48 10 10 10 10-4.48 10-10S22.52 7 17 7zm0 3l3 5h-6l3-5zm-6 6h2.5l-2.5 5.5V16zm3.5 6.5L17 18l2.5 4.5H14.5zm5.5 0V21.5L17.5 16H20l.5 6.5zm2-6l-2.5-5.5H22l-2 5.5z" fill="#4A90D9"/>
                    </svg>
                    <span className="recaptcha-brand">reCAPTCHA</span>
                    <span className="recaptcha-terms">Privacy · Terms</span>
                  </div>
                </label>
              </div>

              <button type="submit" className="contact__submit">
                Submit
              </button>
            </form>
          )}
        </div>

        {/* RIGHT: Image */}
        <div className="">
          {/* <img
            src="https://images.unsplash.com/photo-1594736797933-d0401ba2fe65?w=800&q=85"
            alt="Bride wearing traditional gold jewellery"
            className="contact__img"
          /> */}
          <iframe 
          title="Google Maps Location" // Add this!
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3683.8985037637904!2d88.35643429999999!3d22.5828991!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a027790839c4f69%3A0x808913d06802abf0!2sJks%20jewels%20pvt.Ltd!5e0!3m2!1sen!2sin!4v1778092827697!5m2!1sen!2sin" 
          width="700" 
          height="600"  
          allowFullScreen="" // CamelCase
          loading="lazy" 
          referrerPolicy="no-referrer-when-downgrade" // CamelCase
        ></iframe>
          <div className="contact__image-overlay" />
        </div>
      </div>
    </section>
  );
}
